<template>
  <Modal v-if="userRole" v-model="showModal" :header="false" data-test="rnm-modal">
    <h2 v-if="error" data-test="rnm-error">Oops, there was an error editing this user's role.</h2>
    <div v-else>
      <h2 data-test="rnm-message">
        Are you sure you want to remove {{ userRole.name }} as a {{ userRole.role.toLowerCase() }}?
      </h2>
    </div>
    <template #footer>
      <div class="controls">
        <button class="btn btn-primary" @click="closeModal" data-test="rnm-cancel">Cancel</button>
        <button class="btn btn-default" @click="removeRole(userRole)" data-test="rnm-confirm">
          Confirm
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from "uiv";
import { computed } from "vue";
import { GroupUserRoleApiModel } from "../../../api-models";

const props = defineProps<{
  userRole: GroupUserRoleApiModel | null;
  showNonMemberModal: boolean;
  error: boolean;
}>();

const emit = defineEmits(["remove-non-member-role", "close-non-member-modal"]);

const showModal = computed(() => {
  return props.showNonMemberModal;
});

const closeModal = (): void => {
  emit("close-non-member-modal");
};

const removeRole = (userRole: GroupUserRoleApiModel): void => {
  emit("remove-non-member-role", userRole);
};
</script>

<style scoped lang="less"></style>
